import React, { useRef } from 'react';
import { Navbar, Nav, Container, Button } from 'react-bootstrap';
import { Link, useLocation } from 'react-router-dom';
import { contactInfo } from '../data/businessData';

interface HeaderProps {
  onBookingClick: () => void;
}

const Header: React.FC<HeaderProps> = ({ onBookingClick }) => {
  const location = useLocation();
  const navbarToggleRef = useRef<HTMLButtonElement>(null);

  const handleNavClick = () => {
    // Close mobile menu when nav item is clicked
    if (navbarToggleRef.current && window.innerWidth < 992) {
      navbarToggleRef.current.click();
    }
  };

  return (
    <>
      <div className="bg-dark text-white py-2">
        <Container>
          <div className="row align-items-center">
            <div className="col-md-8">
              <div className="d-flex flex-wrap align-items-center">
                <div className="me-4 mb-1">
                  📞 <small>{contactInfo.phone}</small>
                </div>
                <div className="me-4 mb-1">
                  🕒 <small>{contactInfo.hours}</small>
                </div>
                <div className="mb-1">
                  📍 <small>{contactInfo.address}</small>
                </div>
              </div>
            </div>
            <div className="col-md-4 text-md-end">
              <Button 
                variant="warning" 
                size="sm" 
                onClick={onBookingClick}
                className="fw-bold"
              >
                Book Service Now
              </Button>
            </div>
          </div>
        </Container>
      </div>

      <Navbar bg="white" expand="lg" className="shadow-sm py-3">
        <Container>
          <Navbar.Brand as={Link} to="/" className="fw-bold fs-3 text-primary">
            <img src="/laxmi_logo.png" alt="Laxmi Tyre & Motors" height="40" className="me-2" />
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav" ref={navbarToggleRef} />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="ms-auto">
              <Nav.Link 
                as={Link} 
                to="/" 
                className={`fw-semibold mx-2 ${location.pathname === '/' ? 'active' : ''}`}
                onClick={handleNavClick}
              >
                Home
              </Nav.Link>
              <Nav.Link 
                as={Link} 
                to="/services" 
                className={`fw-semibold mx-2 ${location.pathname === '/services' ? 'active' : ''}`}
                onClick={handleNavClick}
              >
                Services
              </Nav.Link>
              <Nav.Link 
                as={Link} 
                to="/about" 
                className={`fw-semibold mx-2 ${location.pathname === '/about' ? 'active' : ''}`}
                onClick={handleNavClick}
              >
                About
              </Nav.Link>
              <Nav.Link 
                as={Link} 
                to="/our-work" 
                className={`fw-semibold mx-2 ${location.pathname === '/our-work' ? 'active' : ''}`}
                onClick={handleNavClick}
              >
                Our Work
              </Nav.Link>
              <Nav.Link 
                as={Link} 
                to="/reviews" 
                className={`fw-semibold mx-2 ${location.pathname === '/reviews' ? 'active' : ''}`}
                onClick={handleNavClick}
              >
                Reviews
              </Nav.Link>
              <Nav.Link 
                as={Link} 
                to="/contact" 
                className={`fw-semibold mx-2 ${location.pathname === '/contact' ? 'active' : ''}`}
                onClick={handleNavClick}
              >
                Contact
              </Nav.Link>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </>
  );
};

export default Header;